import { Grid, GridItem, HeadingText40 } from '@modernhealth/vital-components';
import { FormattedMessage } from 'react-intl';

import { TopicLinkCard } from 'src/modules/circles/components';
import { SessionCardRowSkeleton } from 'src/modules/circles/components/SessionCardSkeletons';
import { useGetFeaturedQuery } from 'src/modules/circles/documents/featured.generated';
import { isPublicTopic } from 'src/shared/utils/isPublicCircle';

const RowContainer: React.FC = ({ children }) => (
  <section>
    <HeadingText40 marginTop={64} marginBottom={32}>
      <FormattedMessage defaultMessage="Featured Circles" />
    </HeadingText40>
    {children}
  </section>
);

export const FeaturedTopicsRow: React.FC = () => {
  const featuredTopics = useGetFeaturedQuery({});

  if (featuredTopics.loading && !featuredTopics.data) {
    return (
      <RowContainer>
        <SessionCardRowSkeleton />
      </RowContainer>
    );
  }

  const { items } = featuredTopics.data?.circleFeaturedCollection ?? {};

  const anySessions = items?.some(item => item.sessions.totalCount);
  if (!items || items.length === 0 || !anySessions) return null;
  const isAnySessionsEnglish = items?.some(item => isPublicTopic(item));

  if (!isAnySessionsEnglish) return null;
  return (
    <RowContainer>
      <Grid lgMode="3columns">
        {items.flatMap(item => {
          if (!item || item.sessions.totalCount === 0) return [];
          if (item.languageCode !== 'en') return null;
          return (
            <GridItem lg={1} md={2} column key={`session-card-${item.id}`}>
              <TopicLinkCard topic={item} />
            </GridItem>
          );
        })}
      </Grid>
    </RowContainer>
  );
};
